
import { Vue } from "vue-class-component";
export default class Test extends Vue {
  public height = "100%";
  public graph: any = "";
  public mounted() {
    console.log(this.$route.query.name);
    this.graph = this.$route.query.name;
  }
}
